import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const AuthMessage = ({ success, error }) => (
  <div
    style={{ width: '420px' }}
    className={classNames(
      [
        'margin-vertical-large center-text font-weight-medium shade-100 padding-normal radius-normal',
      ],
      {
        'background-purple': success,
        'background-red': error,
      }
    )}
  >
    {success || error}
  </div>
)

export const AuthSuccess = ({ success }) => {
  if (!success) {
    return null
  }

  return <AuthMessage success={success.message} />
}

AuthSuccess.propTypes = {
  success: PropTypes.object,
}

export const AuthError = ({ error }) => {
  const errorMessage = error
    ? error.message
    : 'Oops, an unexpected error happened. Please try again'

  return <AuthMessage error={errorMessage} />
}

AuthError.propTypes = {
  error: PropTypes.object,
}
